"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var ChoiceGroup_base_1 = require("./ChoiceGroup.base");
var ChoiceGroup_styles_1 = require("./ChoiceGroup.styles");
exports.ChoiceGroup = Utilities_1.styled(ChoiceGroup_base_1.ChoiceGroupBase, ChoiceGroup_styles_1.getStyles, undefined, { scope: 'ChoiceGroup' });
//# sourceMappingURL=ChoiceGroup.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/ChoiceGroup/ChoiceGroup.js
// module id = 769
// module chunks = 0